import styled from 'styled-components';

import Hero from '@/assets/gradient.png';

export const Container = styled.section`
  align-items: center;
  background: url(${Hero}) no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  gap: 5vh;
  min-height: 70dvh;
  position: center;
  width: 100%;
  background-position: 77% -105px;
  position: relative;

  @media screen and (max-width: 400px) {
    background-position: center;
    justify-content: unset;
    min-height: 70dvh;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    background-position: center;
    gap: 10vh;
    justify-content: unset;
    min-height: 100dvh;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 0 2rem;
  }
`;

export const ContentWrapper = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  justify-content: end;
  margin-bottom: 1rem;
  max-width: 1070px;
  padding: 0 2rem 2rem;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5vh;
    justify-content: start;
    margin-bottom: 0;
  }
`;
